import React from 'react';
import PropTypes from 'prop-types';
import { Link, Text, Tooltip } from 'components';

export const ServiceTitle = ({ withLink, title, url, description }) => (
  <Text tag="p">
    {withLink ? (<Link href={url} target="_blank">{title}</Link>) : title}
    {description && (<Tooltip>{description}</Tooltip>)}
  </Text>
);

ServiceTitle.propTypes = {
  title: PropTypes.string,
  withLink: PropTypes.bool,
  url: PropTypes.string,
  description: PropTypes.string,
};
